import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from "vue-meta";
import infiniteScroll from 'vue-infinite-scroll';

Vue.prototype.$window = window;

Vue.use(infiniteScroll)
// import VueClazyLoad from "vue-clazy-load";
// Vue.use(VueClazyLoad);
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  preLoad: 1.7,
  lazyComponent: true,
  listenEvents: [
    "scroll",
    "wheel",
    "mousewheel",
    "resize",
    "animationend",
    "transitionend",
    "touchmove"
  ]
});
import IdleVue from "idle-vue";
const eventsHub = new Vue();
const options = {
  eventEmitter: eventsHub,
  idleTime: 1000
};
Vue.use(IdleVue, options);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
